<template>
  <transition name="grow">
    <base-modal
      @close="$emit('close')"
      :head="reassignment ? 'reassign_to_tablet' : 'assign_to_tablet'"
    >
      <FormError :errors="errors" class="text-sm" />
      <div class="flex flex-col sm:flex-row sm:space-x-8 items-center justify-between">
        <div class="w-full sm:w-64 max-w-sm">
          <span class="mb-1 flex font-semibold">{{ $t(`mygwf.components.Form.tour`) }}</span>
          <div class="h-72 overflow-y-scroll space-y-1 border p-4 mb-3">
            <div v-if="tourSelected.name" class="w-full tracking-wide text-sm">
              {{ tourSelected.name }}
            </div>
          </div>
        </div>
        <base-icon
          :class="[
            'text-5xl transform sm:-rotate-90',
            tabletUuid !== '' ? 'text-primary' : 'text-secondary-dark',
          ]"
          icon="arrow-down"
        />
        <div class="items-center sm:w-128">
          <dt class="mb-2 leading-5 font-semibold">
            {{ $t(`mygwf.components.Label.tablet`) }}
          </dt>
          <dd class="leading-5">
            <base-select
              v-model="tabletUuid"
              :placeholder="$t(`mygwf.components.Form.select_tablet`)"
              ref="tablet-selection"
              :options="activeTablets"
              :optionType="{id: 'uuid', label: 'name', group: 'company_name'}"
            />
          </dd>
        </div>
      </div>
      <div class="pt-4 mt-6 border-t flex flex-col justify-end w-full">
        <div class="flex flex-col">
          <div class="flex space-x-4">
            <base-button
              class="w-1/2"
              @click="$emit('close')"
              :disabled="loading"
              action="close"
              context="secondary"
            >
              <base-icon icon="close" />
            </base-button>
            <base-button
              class="w-1/2"
              @click="submit"
              :action="reassignment ? 'reassign_tour' : 'assign_tour'"
              :loading="loading"
            >
              <!--            <base-button
              class="w-1/2"
              @click="submit"
              :action="reassignment ? 'reassign_tour' : 'assign_tour'"
              :loading="loading"
              :disabled="$v.tabletUuid.$invalid"
            >-->
              <base-icon icon="assign" />
            </base-button>
          </div>
        </div>
      </div>
    </base-modal>
  </transition>
</template>

<script>
import {BaseButton, BaseIcon, BaseModal, BaseSelect} from '@/components/base'
import {required} from 'vuelidate/lib/validators'

export default {
  components: {
    BaseButton,
    BaseIcon,
    BaseModal,
    BaseSelect,
    FormError: () => import('@/components/shared/FormError.vue'),
  },

  async mounted() {
    this.tabletList = await this.getTablets()
  },

  props: {
    reassignment: {
      type: Boolean,
      default: false,
    },
    tourSelected: {
      type: Object,
    },
  },
  data() {
    return {
      tabletUuid: '',
      loading: false,
      tabletList: [],
      pk: this.$store.getters['tours/pk'],
      errors: [],
    }
  },
  methods: {
    async submit() {
      try {
        this.loading = true
        let result = null
        let payload = {tablet_uuid: this.tabletUuid}
        // this.tours.forEach(tour => {
        console.log(`Tour selected assigned_to ${this.tourSelected.assigned_to}`)
        console.log(`Tablet ID is: ${this.tabletUuid}`)
        if (!this.tourSelected.assigned_to) {
          console.log('Assigned Is Empty')
          result = await this.$store.dispatch(`tours/assignTablet`, {
            tour: this.tourSelected,
            payload,
          })
        } else {
          console.log('Assigned Is not empty')
          result = await this.$store.dispatch(`tours/reAssignTablet`, {
            tour: this.tourSelected,
            payload,
          })
        }
        // console.log(`Assigned Result keys: ${Object.keys(result)}`)
        // console.log(`Assigned Result values: ${Object.values(result)}`)
        // console.log(result.assigned_to)
        // })
        //const results = await Promise.allSettled(requests)
        await this.$store.dispatch('app/notification', {
          type: 'success',
          group: 'app',
          text: `assigned`,
        })
        this.$emit('success')
        this.$emit('change-tablet-name', result.assigned_to)
        this.$emit('close')
      } catch (errors) {
        this.errors = errors
      } finally {
        this.loading = false
      }
    },
    async getTablets() {
      try {
        const tabletList = await this.$store.dispatch('tablets/getInitialTablets')
        return tabletList.results
      } catch (error) {}
    },
  },
  computed: {
    activeTablets() {
      return this.tabletList.filter(tablet => tablet.is_active === true)
    },
  },
  validations: {
    tabletUuid: {required},
  },
}
</script>
